import { Button, message, Modal } from 'antd';
import React, { useState } from 'react';
import axios from '../../util/Api';

const DeleteButton = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    setLoading(true);
    const url = `/violation/delete`;
    const data = {
      id: id,
    };
    axios.post(url, data).then(resp => {
      if (resp.data.success) {
        window.location.reload();
      } else {
        message.error("Gagal menghapus data");
      }
    }).catch(err => {
      message.error("Gagal menghapus data");
    });
  }
  
  const handleCancel = () => {
    setIsModalVisible(false);
  }

  return (
    <>
      <Button size="small" danger onClick={() => setIsModalVisible(true)}>Delete</Button>
      <Modal title="Hapus Data Pelanggaran" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} okButtonProps={{loading: loading}}>
        Apakah Anda yakin ingin menghapus data ini?
      </Modal>
    </>
  );
}

export default DeleteButton;